// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/fonts/Montserrat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-family: sans-serif;
}

* {
  outline: none;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

html, body{
  scroll-behavior: smooth;
}

body{
  font-family: "Montserrat", sans-serif;
}

.App {
  text-align: center;
}

button,
button:focus {
  outline: none;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.center-block {
  display: flex !important;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.page__title {
  padding: 30px 0;
  width: 100%;
}

.no-result {
  text-align: center;
  width: 100%;
}

.wrapper {
  display: flex;
  align-items: stretch;
  height: 100vh;
  width: 100%;
  background-color: #f5f6f7;
  padding-top: 80px;
}

.row {
  height: 100%;
}

.main-content {
  padding: 0 15px;
}

.menu-container {
  height: 100%;
  margin: 0 -15px;
  background: #fff;
  height: 100%;
  box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.05);
}

.menu-logo {
  margin-bottom: 40px;
  background: #5361f5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
}

.menu-logo svg {
  width: 185px;
  height: 76px;
}

.main-menu {
  padding: 0;
  margin: 0;
  padding-top: 10px;
}

.main-menu li {
  list-style-type: none;
}

.nav-link {
  color: #333;
  text-decoration: none;
  transition: all 0.3s ease-in-out;
  padding: 8px 20px;
  display: flex;
  font-size: 15px;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.nav-link svg {
  margin-right: 20px;
  transition: all 0.3s ease-in-out;
}

.nav-link:hover {
  background: #18bcf2;
  color: #ffffff;
}

.nav-link:hover svg {
  fill: #ffffff;
}

.nav-link.is-active {
  background: #18bcf2;
  color: #ffffff;
}

.nav-link.is-active svg {
  fill: #ffffff;
}

.main-content .table.report-table {
  min-height: auto;
}

.table thead th {
  text-transform: uppercase;
  font-weight: 600;
}

.menu-tab__title {
  display: block;
  padding: 8px 16px;
  color: #ffffff;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 20px;
}

.menu-item__title {
  position: relative;
  display: block;
  cursor: pointer;
  color: #333;
  padding: 5px 16px;
  font-size: 17px;
  text-transform: uppercase;
  font-weight: 600;
  transition: all 0.3s ease-in-out;
}

.menu {
  padding: 0;
  background-color: #384c61;
  transition: all 0.3s ease-in-out;
}

.toggle-menu.active-toggle .menu {
  height: auto;
  opacity: 1;
  visibility: visible;
}

.loader {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.brandsSelect {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 0;
}

.brandsContainer {
  position: relative;
}

.brands {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: absolute;
  padding: 10px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.5);
  background-color: #fff;
  z-index: -100;
  top: 450%;
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.2s ease-in-out;
  opacity: 0;
  visibility: hidden;
  width: 200px;
}

.brands.is-active {
  opacity: 1;
  visibility: visible;
  z-index: 10;
  top: 150%;
}

.brands input {
  margin-right: 5px;
}

.brands:after {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
  position: absolute;
  content: "";
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
}

.brands label {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}

.toggleBrandSelect {
  background-color: #42d0ff;
  width: 200px;
  height: 35px;
  border: 0;
  border-radius: 4px;
  color: #ffffff;
  outline: none;
}

.resetBrandList {
  margin-left: 25px;
  background-color: #4d6680;
  width: 150px;
  height: 35px;
  border: 0;
  border-radius: 4px;
  color: #ffffff;
  outline: none;
}

.dashboard {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 40px;
}

.card {
  width: 16%;
  padding: 15px;
  display: flex;
  align-items: center;
  flex-direction: column;
  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.1);
  margin:10px;
}

.card .content {
  padding: 0;
  background: #fff;
  text-align: center;
}

.title {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
}
.symbol {
  color: #828e99;
  font-size: 20px;
}

.cardStat {
  color: #4383cc;
  font-size: 28px;
}

.table-margin {
  margin-bottom: 40px;
}

.dataTables_wrapper {
  width: 100%;
}

.dataTables_wrapper .row {
  height: auto;
}

.dataTables_wrapper .pagination {
  justify-content: flex-end;
}

.page-link {
  cursor: pointer;
}

.sorting,
.sorting_asc,
.sorting_desc {
  cursor: pointer;
}

.top-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.datepicker__col {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 20px 0;
}
.brandpicker__col {
  width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.top_menu {
  background-color: #5361f5;
  height: 80px;
  box-shadow: 0 5px 9px 0 rgba(0, 0, 0, 0.05);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.top-menu-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.top-main-menu {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 0;
  padding-left: 50px;
}

.top-main-menu li {
  list-style-type: none;
}

.top-nav-link {
  color: #9fa7ff;
  text-decoration: none;
  margin: 0 10px;
  transition: all 0.3s ease-in-out;
  padding-bottom: 5px;
}

.top-nav-link:hover {
  color: #ffffff;
  text-decoration: none;
}

.top-nav-link.is-nav-active {
  color: #ffffff;
  border-bottom: 1px solid #fff;
}

.top-menu-container .menu-logo {
  margin-bottom: 0;
  max-width: 100%;
  height: 100%;
}

.top-main-navbar {
  width: 100%;
}

.top-menu-container .menu-logo svg {
  width: 150px;
  height: 60px;
}

.container {
  position: relative;
}

.data__wrapper {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  margin-bottom: 30px;
  padding: 15px;
  background-color: #ffffff;
}

.fhzgrH div:first-child {
  overflow: visible !important;
  white-space: normal !important;
}

.section-inner{
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-heading{
  display: flex;
  text-align: center;
  justify-content: center;
}

.section-heading h3{
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  font-size: 30px;
}

.section-heading h3:nth-child(2){
  padding-left: 15px;
  color: #4A5CD8;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,4CAA+C;EAC/C,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,2CAA2C;EAC3C,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,gCAAgC;EAChC,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2CAA2C;EAC3C,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,+CAA+C;EAC/C,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":["@font-face {\n  src: url(/src/assets/fonts/Montserrat-Bold.ttf);\n  font-family: sans-serif;\n}\n\n* {\n  outline: none;\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n\nhtml, body{\n  scroll-behavior: smooth;\n}\n\nbody{\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.App {\n  text-align: center;\n}\n\nbutton,\nbutton:focus {\n  outline: none;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.center-block {\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.page__title {\n  padding: 30px 0;\n  width: 100%;\n}\n\n.no-result {\n  text-align: center;\n  width: 100%;\n}\n\n.wrapper {\n  display: flex;\n  align-items: stretch;\n  height: 100vh;\n  width: 100%;\n  background-color: #f5f6f7;\n  padding-top: 80px;\n}\n\n.row {\n  height: 100%;\n}\n\n.main-content {\n  padding: 0 15px;\n}\n\n.menu-container {\n  height: 100%;\n  margin: 0 -15px;\n  background: #fff;\n  height: 100%;\n  box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.05);\n}\n\n.menu-logo {\n  margin-bottom: 40px;\n  background: #5361f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 0;\n}\n\n.menu-logo svg {\n  width: 185px;\n  height: 76px;\n}\n\n.main-menu {\n  padding: 0;\n  margin: 0;\n  padding-top: 10px;\n}\n\n.main-menu li {\n  list-style-type: none;\n}\n\n.nav-link {\n  color: #333;\n  text-decoration: none;\n  transition: all 0.3s ease-in-out;\n  padding: 8px 20px;\n  display: flex;\n  font-size: 15px;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.nav-link svg {\n  margin-right: 20px;\n  transition: all 0.3s ease-in-out;\n}\n\n.nav-link:hover {\n  background: #18bcf2;\n  color: #ffffff;\n}\n\n.nav-link:hover svg {\n  fill: #ffffff;\n}\n\n.nav-link.is-active {\n  background: #18bcf2;\n  color: #ffffff;\n}\n\n.nav-link.is-active svg {\n  fill: #ffffff;\n}\n\n.main-content .table.report-table {\n  min-height: auto;\n}\n\n.table thead th {\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.menu-tab__title {\n  display: block;\n  padding: 8px 16px;\n  color: #ffffff;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 20px;\n}\n\n.menu-item__title {\n  position: relative;\n  display: block;\n  cursor: pointer;\n  color: #333;\n  padding: 5px 16px;\n  font-size: 17px;\n  text-transform: uppercase;\n  font-weight: 600;\n  transition: all 0.3s ease-in-out;\n}\n\n.menu {\n  padding: 0;\n  background-color: #384c61;\n  transition: all 0.3s ease-in-out;\n}\n\n.toggle-menu.active-toggle .menu {\n  height: auto;\n  opacity: 1;\n  visibility: visible;\n}\n\n.loader {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.brandsSelect {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 20px 0;\n}\n\n.brandsContainer {\n  position: relative;\n}\n\n.brands {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  position: absolute;\n  padding: 10px;\n  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.5);\n  background-color: #fff;\n  z-index: -100;\n  top: 450%;\n  left: 50%;\n  transform: translateX(-50%);\n  transition: all 0.2s ease-in-out;\n  opacity: 0;\n  visibility: hidden;\n  width: 200px;\n}\n\n.brands.is-active {\n  opacity: 1;\n  visibility: visible;\n  z-index: 10;\n  top: 150%;\n}\n\n.brands input {\n  margin-right: 5px;\n}\n\n.brands:after {\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 10px solid #fff;\n  position: absolute;\n  content: \"\";\n  top: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.brands label {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n}\n\n.toggleBrandSelect {\n  background-color: #42d0ff;\n  width: 200px;\n  height: 35px;\n  border: 0;\n  border-radius: 4px;\n  color: #ffffff;\n  outline: none;\n}\n\n.resetBrandList {\n  margin-left: 25px;\n  background-color: #4d6680;\n  width: 150px;\n  height: 35px;\n  border: 0;\n  border-radius: 4px;\n  color: #ffffff;\n  outline: none;\n}\n\n.dashboard {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 40px;\n}\n\n.card {\n  width: 16%;\n  padding: 15px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.1);\n  margin:10px;\n}\n\n.card .content {\n  padding: 0;\n  background: #fff;\n  text-align: center;\n}\n\n.title {\n  text-align: center;\n  font-size: 18px;\n  font-weight: 600;\n}\n.symbol {\n  color: #828e99;\n  font-size: 20px;\n}\n\n.cardStat {\n  color: #4383cc;\n  font-size: 28px;\n}\n\n.table-margin {\n  margin-bottom: 40px;\n}\n\n.dataTables_wrapper {\n  width: 100%;\n}\n\n.dataTables_wrapper .row {\n  height: auto;\n}\n\n.dataTables_wrapper .pagination {\n  justify-content: flex-end;\n}\n\n.page-link {\n  cursor: pointer;\n}\n\n.sorting,\n.sorting_asc,\n.sorting_desc {\n  cursor: pointer;\n}\n\n.top-line {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.datepicker__col {\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 20px 0;\n}\n.brandpicker__col {\n  width: 50%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.top_menu {\n  background-color: #5361f5;\n  height: 80px;\n  box-shadow: 0 5px 9px 0 rgba(0, 0, 0, 0.05);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1000;\n}\n\n.top-menu-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.top-main-menu {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  margin-bottom: 0;\n  padding-left: 50px;\n}\n\n.top-main-menu li {\n  list-style-type: none;\n}\n\n.top-nav-link {\n  color: #9fa7ff;\n  text-decoration: none;\n  margin: 0 10px;\n  transition: all 0.3s ease-in-out;\n  padding-bottom: 5px;\n}\n\n.top-nav-link:hover {\n  color: #ffffff;\n  text-decoration: none;\n}\n\n.top-nav-link.is-nav-active {\n  color: #ffffff;\n  border-bottom: 1px solid #fff;\n}\n\n.top-menu-container .menu-logo {\n  margin-bottom: 0;\n  max-width: 100%;\n  height: 100%;\n}\n\n.top-main-navbar {\n  width: 100%;\n}\n\n.top-menu-container .menu-logo svg {\n  width: 150px;\n  height: 60px;\n}\n\n.container {\n  position: relative;\n}\n\n.data__wrapper {\n  width: 100%;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 5px;\n  box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.05);\n  background-color: #ffffff;\n  margin-bottom: 30px;\n  padding: 15px;\n  background-color: #ffffff;\n}\n\n.fhzgrH div:first-child {\n  overflow: visible !important;\n  white-space: normal !important;\n}\n\n.section-inner{\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.section-heading{\n  display: flex;\n  text-align: center;\n  justify-content: center;\n}\n\n.section-heading h3{\n  font-family: 'Montserrat', sans-serif;\n  font-weight: bold;\n  font-size: 30px;\n}\n\n.section-heading h3:nth-child(2){\n  padding-left: 15px;\n  color: #4A5CD8;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
